<section *ngIf="visible">
  <h2 *ngIf="!sensorFailure.sensor_fail_number">Add Sensor Failure</h2>
  <h2 *ngIf="sensorFailure.sensor_fail_number">Sensor Failure</h2>
</section>
<section class="p-fluid" *ngIf="visible">
  <form [formGroup]="editForm" (ngSubmit)="sensorFailure.alert_status" novalidate>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-col-6 p-col-nopad p-col-row">
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="pod_serial_number">Pod Serial Number</label>
          <input ngDefaultControl formControlName="pod_serial_number" type="text"
            [ngModel]="sensorFailure.pod_serial_number" pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="location_name">Pod Location</label>
          <input ngDefaultControl formControlName="location_name" type="text" [ngModel]="sensorFailure.location_name"
            pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="sale_type">Sale Type</label>
          <input ngDefaultControl formControlName="sale_type" type="text" [ngModel]="sensorFailure.sale_type"
            pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="distributor_name">Distributor</label>
          <input ngDefaultControl formControlName="distributor_name" type="text"
            [ngModel]="sensorFailure.distributor_name" pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="owner_name">Owner Name</label>
          <input ngDefaultControl formControlName="owner_name" type="text" [(ngModel)]="sensorFailure.owner_name"
            pInputText />
        </div>
        <div class="p-field p-col-6 p-col-row no-float">
          <label for="sensor_serial_number">Sensor Serial Number</label>
          <input ngDefaultControl formControlName="sensor_serial_number" type="text"
            [(ngModel)]="sensorFailure.sensor_serial_number" pInputText />
        </div>
        <div class="p-field p-col-4 p-col-row no-float">
          <label for="sensor_type">Sensor Type</label>
          <input ngDefaultControl formControlName="sensor_type" type="text" [(ngModel)]="sensorFailure.sensor_type"
            pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="installation_date">Fitted Date</label><br>
          <input ngDefaultControl formControlName="installation_date" type="text"
            [(ngModel)]="sensorFailure.installation_date_fmt" pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="fail_reason">Failure Reason</label>
          <input ngDefaultControl formControlName="fail_reason" type="text" [(ngModel)]="sensorFailure.fail_reason"
            pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="alert_status_description">Alert Status</label>
          <input ngDefaultControl formControlName="alert_status_description" type="text"
            [(ngModel)]="sensorFailure.alert_status_description" pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row">
          <div class="p-col-6 p-col-row">
            <label>Ship Sensors To Owner</label><br>
            <p-checkbox ngDefaultControl formControlName="ship_sensors_to_owner"
              [(ngModel)]="sensorFailure.ship_sensors_to_owner" binary="true"></p-checkbox>
          </div>
          <div class="p-field p-col-6 p-col-row">
            <label>Block Sending Sensors</label><br>
            <p-checkbox ngDefaultControl formControlName="block_sending_sensors"
              [(ngModel)]="sensorFailure.block_sending_sensors" binary="true"></p-checkbox>
          </div>
        </div>
      </div>
      <div class="p-col-6 p-col-nopad p-col-row">
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="pod_status">Pod Status</label>
          <input ngDefaultControl formControlName="pod_status" type="text" [(ngModel)]="sensorFailure.pod_status"
            pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="replacement_sensor_serial">Replacement Sensor Serial</label>
          <input ngDefaultControl formControlName="replacement_sensor_serial" type="text"
            [(ngModel)]="sensorFailure.replacement_sensor_serial" pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="age_in_months">Age in months</label>
          <input ngDefaultControl formControlName="age_in_months" type="number"
            [(ngModel)]="sensorFailure.age_in_months" pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="failure_date">Failure Date</label><br>
          <input ngDefaultControl formControlName="failure_date" type="text"
            [(ngModel)]="sensorFailure.failure_date_fmt" pInputText />
        </div>
        <div class="p-field p-col-12 p-col-row no-float">
          <label for="shipped_date">Shipped Date</label><br>
          <input ngDefaultControl formControlName="shipped_date" type="text"
            [(ngModel)]="sensorFailure.shipped_date_fmt" pInputText />
        </div>
        <div class="p-field p-col-8">
          <label for="notes">Notes</label> <br />
          <p-autoComplete ngDefaultControl formControlName="notes" [(ngModel)]="noteSelected"
            [suggestions]="typeAheadFiltered" (completeMethod)="autoComplete($event)" [size]="100"
            field="notes">{{typeAheadFiltered}}</p-autoComplete>
        </div>
      </div>
      <div class="p-col-12 p-col-row p-grid">
        <div class="p-col-6">
          <table class="table table-borderless" style="height: 125px; width: 100%; table-layout: fixed">
            <thead>
              <th class="bg-grey"> Phase 1 - Confirmation </th>
              <th class="bg-danger-light"> Phase 2 - Shipping </th>
              <th class="bg-warning-light"> Phase 3 - Change Sensor </th>
              <th class="bg-success-light"> Phase 4 - Completion </th>
            </thead>
            <tr>
              <td class="bg-grey">
                <p-splitButton *ngIf="showConfirm" label="Failed sensor" icon="pi pi-stamp" (onClick)="confirm()"
                  [model]="confirmItems" styleClass="p-button-warning bs5" menuStyleClass="p-button-warning"
                  [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted">
                </p-splitButton>
                <button *ngIf="showFalsePos" label="False Positive" type="button" icon="pi pi-thumbs-up"
                  class="p-button-raised  p-button-info bs5" pButton (click)="falsePos()" positionStyle="fixed"
                  pTooltip="Sensor has NOT failed, set False Positive."
                  [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted">
                </button>
              </td>
              <td class="bg-danger-light">
                <p-splitButton *ngIf="showContact" label="{{contactOption}}" icon="pi pi-comment-alt"
                  (onClick)="contactDefault()" [model]="contactItems" styleClass="p-button-danger bs5"
                  menuStyleClass="p-button-light-danger"
                  [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted">
                </p-splitButton>
                <button *ngIf="showEmailOnly" label="Email Reminder" type="button" icon="pi pi-envelope"
                  class="p-button-raised  p-button-danger bs5" pButton (click)="emailNote()" positionStyle="fixed"
                  pTooltip="Email a note." [disabled]="submitted">
                </button>
              </td>
              <td class="bg-warning-light">
                <p-splitButton *ngIf="showAction" label="{{actionOption}}" icon="pi pi-running"
                  (onClick)="actionDefault()" [model]="actionItems" styleClass="p-button-warning bs5"
                  menuStyleClass="p-button-light-warning"
                  [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted">
                </p-splitButton>
                <button *ngIf="showChangedOnly" label="{{actionOption}}" type="button" icon="pi pi-refresh"
                  class="p-button-raised  p-button-light-warning" pButton (click)="sensorChanged()"
                  positionStyle="fixed" pTooltip="Sensor has been replaced." [disabled]="submitted">
                </button>
                <button *ngIf="showReturnedOnly" label="{{actionOption}}" type="button" icon="pi pi-refresh"
                  class="p-button-raised  p-button-light-warning" pButton (click)="sensorReturned()"
                  positionStyle="fixed" pTooltip="Sensor has been returned." [disabled]="submitted">
                </button>
              </td>
              <td class="bg-success-light">
                <p-splitButton *ngIf="showClose && completionItems.length !== 0" label="{{closeOption}}"
                  icon="pi pi-running" (onClick)="actionDefault()" [model]="completionItems"
                  styleClass="p-button-success bs5" menuStyleClass="p-button-light-success"
                  [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted"></p-splitButton>
                <button *ngIf="showClose && completionItems.length === 0" label="{{closeOption}}" type="button"
                  icon="pi pi-exclamation-triangle" class="p-button-raised  p-button-success bs5" pButton
                  (click)="sensorReturned()" positionStyle="fixed" pTooltip="Process completion - close the alert"
                  [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted"></button>
              </td>
            </tr>
          </table>
        </div>
        <div class="p-col-6 p-grid p-ai-end p-jc-end vertical-container">
          <div class="p-col-2">
            <button label="Add New Note" type="button" icon="pi pi-pencil" class="p-button-raised  p-button-primary bs5"
              pButton (click)="addNote()" positionStyle="fixed" pTooltip="Add note to history."
              [disabled]="!has(Permission.Sensors_Failure_Full_Control) || submitted"></button>
          </div>
          <div class="p-col-2">
            <button label="Close" type="button" icon="far fa-window-close" class="p-button-raised  p-button-warning bs5"
              pButton (click)="exit()" positionStyle="fixed" pTooltip="Return to the list of failures."
              [disabled]="submitted"></button>
          </div>
        </div>
      </div>
    </div>
  </form>
</section>
<p-dialog header="Menu button help" [(visible)]="showSplitButtonHelp" [modal]="true"
  [style]="{width: '350px', minWidth: '200px'}" [minY]="70" [maximizable]="false" [baseZIndex]="1000">
  <p>Use the dropdown button at the left to show options!</p>
  <div class="p-grid">
    <div class="p-col-3">
      <button type="button" pButton icon="pi pi-close" (click)="showSplitButtonHelp=false" label="Close"></button>
    </div>
  </div>
</p-dialog>
<p-confirmDialog header="Confirmation" key="areYouSure" width="300"></p-confirmDialog>
